import _ from 'lodash';
import Section from "../components/Section";
import {Button} from "../components/Button";
import UIState from "../store/uiState";
import {ModalTypes, STAKING_DISABLED} from "../constants";
import {useDispatch, useSelector} from "react-redux";
import {createSelector} from "reselect";
import {copyToClipboard, countdownRenderText, formatBalance, truncate} from "../utils";
import Wallet, {selectCurrentAccount, selectNFTBalances, selectStoreProductsByType} from "../store/models/wallet";
import React, {useEffect, useRef, useState} from "react";
import {usePageVisibility} from "../hooks/usePageVisibility";
import {StakeAPYCTA, StakeAPYInfo} from "../components/CTAPill";
import {useTranslation} from "react-i18next";
import logo from "../assets/logos/grove@2x.png";
import metamaskLogo from "../assets/wallets/metamask-white@2x.png";
import thetaWalletLogo from "../assets/wallets/theta-wallet-white@2x.png";
import CharacterViewer from "../components/CharacterViewer";
import {Tab, TabList, Tabs} from "react-tabs";
import tokenIcon from "../assets/logos/grove@2x.png";
import cardCheckmark from "../assets/icons/card/purple-checkmark@2x.png";
import cardNew from "../assets/icons/card/new@2x.png";
import cardSoldOut from "../assets/icons/card/sold-out@2x.png";
import cardExclusive from "../assets/icons/card/exclusive@2x.png";
import classNames from "classnames";
import PurchaseButton from "../components/PurchaseButton";
import GetMoreGroveButton from "../components/GetMoreGroveButton";
import useMediaQuery from "../hooks/useMediaQuery";
import exclamationIcon from "../assets/icons/card/alert@2x.png";
import {
    EmailShareButton, FacebookIcon,
    FacebookShareButton,
    RedditShareButton,
    TwitterShareButton,
    WhatsappShareButton
} from "react-share";
import Items, {getItemByModelName} from "../items";
import toast from "react-hot-toast";
import Sqids from "sqids";
import Storage from "../utils/storage";
import Countdown from "react-countdown";

const sqids = new Sqids();
const moment = require("moment");

const ItemTypeToDisplayName = {
    character: 'Characters',
    weapon: 'Weapons',
    back_swag: 'Back Swag'
};

const renderAvailableFor = (countDownData) => {
    if (countDownData.completed) {
        return (
            <span>
                Ended
            </span>
        );
    }

    return (
        <span>
            {`${countdownRenderText(countDownData)}`}
        </span>
    )
}


export const BuilderItemCard = ({item, onSelectItem, onApplyItem, ownedAmount, isApplied}) => {
    return (
        <div className={classNames('BuilderItemCard', {
            'BuilderItemCard--applied': isApplied,
            'BuilderItemCard--owned': ownedAmount > 0,
            'BuilderItemCard--new': item.is_new,
            'BuilderItemCard--featured': item.is_featured
        })}
             onClick={() => onSelectItem(item)}
        >
            <div className={'BuilderItemCard__image'}>
                <img src={`${item.image}`}
                     alt={item.name}/>
            </div>
            <div className={'BuilderItemCard__details'}>
                <div className={'BuilderItemCard__details__name'}>
                    {item.name}
                </div>
                {
                    ownedAmount === 0 &&
                    <div className={'BuilderItemCard__details__price'}>
                        <img src={tokenIcon}/>
                        <span>{item.price === 0 ? 'FREE' : item.price}</span>
                    </div>
                }
                {
                    ownedAmount > 0 &&
                    <Button className={'BuilderItemCard__details__button'}
                            onClick={(e) => {
                                e.stopPropagation();
                                e.preventDefault();
                                onApplyItem(item);
                            }}
                            color={isApplied ? 'purple-light' : 'red'}
                            size={'xsmall'}
                    >
                        {isApplied ? 'Applied' : 'Apply'}
                    </Button>
                }
            </div>
            {
                ownedAmount > 0 &&
                <img src={cardCheckmark}
                     className={'BuilderItemCard__checkmark'}
                />
            }
            {
                ownedAmount === 0 &&
                <div className={'BuilderItemCard__tags'}>
                    {
                        !_.isNil(item?.product?.endsAt) &&
                        <div className={'BuilderItemCard__time-left-tag'}>
                            <Countdown
                                date={(new Date(item?.product?.endsAt))}
                                renderer={renderAvailableFor}
                            />
                        </div>
                    }
                    {
                        item.is_new &&
                        <img src={cardNew}
                             className={'BuilderItemCard__new-tag'}
                        />
                    }
                    {
                        item?.product?.remaining === 0 &&
                        <img src={cardSoldOut}
                             className={'BuilderItemCard__sold-out-tag'}
                        />
                    }
                    {
                        item?.is_exclusive &&
                        <img src={cardExclusive}
                             className={'BuilderItemCard__exclusive-tag'}
                        />
                    }
                    {
                        item.show_remaining && !_.isNil(item?.product?.remaining) &&
                        <div className={'BuilderItemCard__remaining-tag'}>
                        <span>
                            {item?.product?.remaining} left
                        </span>
                        </div>
                    }
                </div>
            }
        </div>
    );
}

const BuilderPaneItems = ({characterSpec, tryOnSpec, onApplyItem, onSelectItem}) => {
    const itemsByType = useSelector(selectStoreProductsByType);
    const nftBalances = useSelector(selectNFTBalances);
    const isMobile = useMediaQuery(768);
    const [tabIndex, setTabIndex] = useState(isMobile ? -1 : 0);
    const isShowing = isMobile ? tabIndex > -1 : true;
    const ownedAmount = 2;
    let itemsToDisplay = [];
    let title = null;
    const localOnApplyItem = (item) => {
        onApplyItem(item);
        if (isMobile) {
            setTabIndex(-1);
        }
    }

    if (tabIndex > -1) {
        const data = itemsByType[Object.keys(itemsByType)[tabIndex]];
        itemsToDisplay = data;
        title = ItemTypeToDisplayName[data[0].type];
    }

    useEffect(() => {
        if (isMobile) {
            setTabIndex(-1);
        }
    }, [characterSpec]);

    return (
        <div className={classNames('BuilderPaneItems', {
            'BuilderPaneItems--is-collapsed': !isShowing,
        })}
        >
            {
                isMobile && isShowing &&
                <div className={'BuilderPaneItems__overlay'}
                     onClick={() => {
                         setTabIndex(-1);
                     }}
                >
                </div>
            }
            <div className={classNames('BuilderPaneItems__header', {
                'BuilderPaneItems__header--is-collapsed': !isShowing,
                'BuilderPaneItems__header--has-shadow': (isMobile && isShowing),
            })}>

                <Tabs selectedIndex={tabIndex}
                      onSelect={(index) => {
                          // Scroll to top when switching tabs (make it animated)
                          window.scrollTo({top: 0, behavior: 'smooth'});


                          if (isMobile && index === tabIndex) {
                              index = -1;
                          }
                          setTabIndex(index);
                      }}
                      className={'Tabs'}>
                    <TabList className={'TabList'}>
                        <Tab>
                            <span>{ItemTypeToDisplayName.character}</span>
                            {!_.isNil(tryOnSpec.character) && <img src={exclamationIcon}/>}
                        </Tab>
                        <Tab>
                            <span>{ItemTypeToDisplayName.weapon}</span>
                            {!_.isNil(tryOnSpec.weapon) && <img src={exclamationIcon}/>}
                        </Tab>
                        <Tab>
                            <span>{ItemTypeToDisplayName.back_swag}</span>
                            {!_.isNil(tryOnSpec.back_swag) && <img src={exclamationIcon}/>}
                        </Tab>
                    </TabList>
                </Tabs>
            </div>

            <div className={'BuilderPaneItemsTabContent'}>
                {
                    title &&
                    <div className={'BuilderPaneItems__title'}>
                        {title}
                    </div>
                }
                {
                    !_.isEmpty(itemsToDisplay) &&
                    <div className={'BuilderItemCardsList'}>
                        {
                            itemsToDisplay.map((item, i) => {
                                const isApplied = characterSpec[item.type] === item.modelName;
                                const ownedAmount = nftBalances[item.contract_address] || 0;

                                return <BuilderItemCard item={item}
                                                        onSelectItem={onSelectItem}
                                                        onApplyItem={localOnApplyItem}
                                                        ownedAmount={ownedAmount}
                                                        isApplied={isApplied}
                                                        key={item.name}
                                />
                            })
                        }
                    </div>
                }
            </div>


            {
                isMobile && isShowing &&
                <div className={'BuilderPaneItems__footer'}>
                    <Button color={'purple'}
                            size={'large'}
                            style={{width: '100%'}}
                            onClick={() => {
                                setTabIndex(-1);
                            }}
                    >
                        Close
                    </Button>
                </div>
            }
        </div>
    )
}

const BuilderPage = () => {
    const isMobile = useMediaQuery(768);
    const [dimensions, setDimensions] = useState(null);
    const nftBalances = useSelector(selectNFTBalances);
    const {t} = useTranslation();
    const account = useSelector(selectCurrentAccount);
    const isVisible = usePageVisibility();
    const dispatch = useDispatch();
    const viewerRef = useRef(null);
    const characterViewerRef = useRef(null);
    const [characterSpec, setCharacterSpec] = useState({
        character: 'Pineya',
        weapon: 'The_Juicer_Pistol',
        back_swag: 'Pineapple_Bag'
    });
    const [tryOnSpec, setTryOnSpec] = useState({
        character: null,
        weapon: null,
        back_swag: null
    });
    const isTryOnMode = _.some(tryOnSpec, (v) => v !== null);
    const tryOnModeCategories = _.filter(Object.keys(tryOnSpec), (k) => tryOnSpec[k] !== null).length;
    console.log('dimensions == ', dimensions);
    console.log('nftBalances == ', nftBalances);
    console.log('tryOnModeCategories == ', tryOnModeCategories);

    const storeCharacterSpec = (newCharacterSpec) => {
        if(account){
            Storage.setItem(`characterSpec_${account.toLowerCase()}`, JSON.stringify(newCharacterSpec));
        }
    }

    useEffect(() => {
        if(account && characterViewerRef?.current?.isLoaded){
            Storage.setItem(`characterSpec_${account.toLowerCase()}`, JSON.stringify(characterSpec));
        }
    }, [account, characterSpec]);

    useEffect(() => {
        if(!_.isNil(tryOnSpec.character)){
            const item = getItemByModelName(tryOnSpec.character);
            if(item && nftBalances[item.contract_address] > 0){
                setTryOnSpec({
                    ...tryOnSpec,
                    character: null
                });
            }
        }
        if(!_.isNil(tryOnSpec.weapon)){
            const item = getItemByModelName(tryOnSpec.weapon);
            if(item && nftBalances[item.contract_address] > 0){
                setTryOnSpec({
                    ...tryOnSpec,
                    weapon: null
                });
            }
        }
        if(!_.isNil(tryOnSpec.back_swag)){
            const item = getItemByModelName(tryOnSpec.back_swag);
            if(item && nftBalances[item.contract_address] > 0){
                setTryOnSpec({
                    ...tryOnSpec,
                    back_swag: null
                });
            }
        }
    }, [nftBalances]);


    useEffect(() => {
        if(account){
            const characterSpec = Storage.getItem(`characterSpec_${account.toLowerCase()}`);
            console.log('[RELOAD_CHARACTER_SPEC] :: characterSpec == ', characterSpec);
            if(characterSpec){
                setCharacterSpec(JSON.parse(characterSpec));
            }
        }
        else{
            console.log('[RELOAD_CHARACTER_SPEC] No account found')
        }
    }, [account]);


    const buildShareUrl = () => {
        const characterId = getItemByModelName(characterSpec.character).id;
        const weaponId = getItemByModelName(characterSpec.weapon).id;
        const backSwagId = getItemByModelName(characterSpec.back_swag).id;
        const hashId = sqids.encode([characterId, weaponId, backSwagId]);
        const shareUrl = `https://warrior.grovewars.com/v/${hashId}`;

        return shareUrl;
    }

    useEffect(() => {
        const updateDimensions = () => {
            if (viewerRef.current) {
                setDimensions({
                    x: viewerRef.current.offsetLeft,
                    y: viewerRef.current.offsetTop,
                    width: viewerRef.current.offsetWidth,
                    height: viewerRef.current.offsetHeight,
                });
            }
        };

        // Initial size update
        updateDimensions();

        // Update size on window resize
        window.addEventListener('resize', updateDimensions);

        // Cleanup event listener on component unmount
        return () => window.removeEventListener('resize', updateDimensions);
    }, []);

    useEffect(() => {
        dispatch(Wallet.actions.tryToRecoverWalletSession());
    }, []);



    const onApplyItem = (item) => {
        setTryOnSpec({
            ...tryOnSpec,
            [item.type]: null
        });

        const nextSpec = {
            ...characterSpec,
            [item.type]: item.modelName
        };
        setCharacterSpec(nextSpec);
        storeCharacterSpec(nextSpec);
    }

    const onTryOnItem = (item) => {
        setTryOnSpec({
            ...tryOnSpec,
            [item.type]: item.modelName
        });
        setCharacterSpec({
            ...characterSpec,
            [item.type]: item.modelName
        });
    }

    return (
        <div className={'Page BuilderPage'}>
            <div className={'BuilderPage__content'}>
                <div className={'BuilderPage__panes'}>
                    <BuilderPaneItems onSelectItem={(item) => {
                        dispatch(UIState.actions.showModal(ModalTypes.Item, {
                            item: item,
                            onApplyItem: onApplyItem,
                            onTryOnItem: onTryOnItem,
                        }));
                    }}
                                      onApplyItem={onApplyItem}
                                      characterSpec={characterSpec}
                                      tryOnSpec={tryOnSpec}
                    />
                    <div className={'BuilderPaneViewer'}
                         ref={viewerRef}>
                        <div className={'BuilderPaneViewer__fixed-container'}
                             style={{
                                 left: dimensions ? dimensions.x : 0,
                                 top: (dimensions ? dimensions.y : 0) + (isMobile ? 40 : 0),
                             }}
                        >
                            {
                                isTryOnMode &&
                                <div className={'TryOnModeBanner'}>
                                    {tryOnModeCategories === 1 && 'TRY-ON MODE: YOU DO NOT OWN 1 ITEM'}
                                    {tryOnModeCategories > 1 && `TRY-ON MODE: YOU DO NOT OWN ${tryOnModeCategories} ITEMS`}
                                </div>
                            }

                            {
                                dimensions &&
                                <CharacterViewer height={Math.min((dimensions.height - 160), 800)}
                                                 width={dimensions.width}
                                                 spec={characterSpec}
                                                 ref={characterViewerRef}
                                />
                            }
                            <div className={'BuilderPaneViewer__footer'}>
                                {/*<PurchaseButton price={200}*/}
                                {/*                text={'Mint NFT'}*/}
                                {/*/>*/}
                                <Button color={'red'}
                                        size={'large'}
                                        onClick={() => {
                                            // copy shareUrl to clipboard
                                            const shareUrl = buildShareUrl();
                                            copyToClipboard(shareUrl);
                                            toast.success(`Share link copied to clipboard!`);
                                        }}
                                        className={'BuilderPaneViewer__mint-soon-button'}
                                >
                                    Share Your Warrior
                                </Button>
                                <GetMoreGroveButton/>
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
};

export default BuilderPage;